import React from 'react';
import { render } from 'react-dom';
import { makeData, Logo, Tips, round } from '../Utility/utility.js';
import Tooltip from 'rc-tooltip';

export class BigCalendarEvent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false
    };
  }

  render() {
    return (
      <div style={{ background: 'red', width: '100%', height: '100%' }}>
        <Tooltip
          prefixCls="rc-slider-tooltip"
          overlay={'HI'}
          visible={this.state.visible}
          placement="top"
        >
          <span>THIS IS MY EVENT</span>
        </Tooltip>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/BigCalendarEvent.js